import React from 'react';

const Services = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Our Services</h1>
        <p>Comprehensive solutions for your business needs</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="content-grid">
          <div className="content-card">
              <h2>VIP Services</h2>
              <p>Premium concierge and business support services.</p>
              <button className="btn-gold" onClick={() => window.location.href='/vip-services'}>Learn More</button>
            </div>
            
            <div className="content-card">
              <h2>Exports & Turnkey Solutions</h2>
              <p>End-to-end export solutions and turnkey projects.</p>
              <button className="btn-gold" onClick={() => window.location.href='/exports'}>Learn More</button>
            </div>
           
            <div className="content-card">
              <h2>Business Incubator</h2>
              <p>Nurturing startups and emerging businesses.</p>
              <button className="btn-gold" onClick={() => window.location.href='/business-incubator'}>Learn More</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;